export default __webpack_public_path__ + "static/mobileWebImage-9675045221d82a79398151a31b37c12d.png";